import React, { Component } from "react";
import FormSummary from "@components/FormSummary";
import { Button, Card, Row, Col } from "antd";
import { getQRcode } from "@api/QRcode";
import { getAllGames } from "@api/statistics";
// import bus from '@utils/bus';
import UrlLink from "./UrlLink";
import { downloadjs } from "@utils/tool";

export default class QRcode extends Component {
  formRef = React.createRef();

  state = {
    formItems: [
      {
        key: "gameId",
        label: "游戏",
        require: true,
        componentName: "select",
        message: "请选择游戏",
        options: [],
      },
      {
        key: "channel",
        label: "渠道号",
        require: true,
        componentName: "input",
        message: "请填写渠道号",
      },
      {
        key: "width",
        label: "宽度",
        require: true,
        componentName: "input",
        message: "请填写二维码宽度",
      },
    ],
    formDefaultValue: {
      width: 320,
    },
    operateType: "",
  };

  componentWillMount() {
    this.getAllGames();
  }

  getAllGames = () => {
    getAllGames().then((res) => {
      const games = res.data.data || [];
      let tempData = [];
      let jsonAllGames = {};

      games.forEach((item) => {
        if (!jsonAllGames[item.gameId]) {
          tempData.push({
            value: item.gameId,
            label: item.gameName || item.gameId,
          });
          jsonAllGames[item.gameId] = item.gameName;
        }
      });

      const temp = this.state.formItems;
      temp[0].options = [];
      temp[0].options = tempData;
      this.setState({
        formItems: temp,
      });
    });
  };

  getCode = async () => {
    let demo = this.formRef.current;
    try {
      const value = await demo.validateFields();
      const res = await getQRcode(value);
      downloadjs(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    return (
      <div style={{ paddingBottom: "20px" }}>
        <h2 style={{ marginTop: 8 }}>生成推广二维码</h2>
        <Card title="设置二维码参数" bordered={false} style={{ marginTop: 28 }}>
          <FormSummary
            labelCols={4}
            operateType={this.state.operateType}
            formDefaultValue={this.state.formDefaultValue}
            ref={this.formRef}
            formItems={this.state.formItems}
          />
          <Row>
            <Col span={20} offset={4}>
              <Button type="primary" onClick={this.getCode}>
                生成二维码
              </Button>
            </Col>
          </Row>
        </Card>
        <UrlLink
          gameList={this.state.formItems[0].options}
          style={{ marginTop: "2vh" }}
        />
      </div>
    );
  }
}

